import { useContext, useEffect, useRef } from "react";
import axios from "axios";
import { Context } from "./Reducers/Store";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Login from "./pages/Auth/Login";
import PrimeiroAdmin from "./pages/Auth/PrimeiroAdmin";
import Dashboard from "./pages/Dashboard/Dashboard";
import JobsPage from "./pages/Jobs/JobsPage";
import AutenticacoesPage from "./pages/Autenticacoes/AutenticacoesPage";
import GruposComunicacaoErroPage from "./pages/GruposComunicacaoErro/GruposComunicacaoErroPage";
import UsuariosPage from "./pages/Usuarios/UsuariosPage";
import ExecucoesPage from "./pages/Execucoes/ExecucoesPage";
import LayoutEmpty from "./pages/Layouts/LayoutEmpty";
import LayoutDashboard from "./pages/Layouts/LayoutDashboard";
import RequireAuth from "./RequireAuth";
import { apiUrl, getPayload } from "./services/apiConfig";

export default function App() {
  const firstLoad = useRef(true);
  const navigate = useNavigate();
  const location = useLocation();
  const [state, dispatch] = useContext(Context);

  useEffect(() => {
    const jwt = localStorage.getItem("jwt");
    const refreshToken = localStorage.getItem("refreshToken");

    if (refreshToken) {
      axios
        .post(apiUrl("/auth/refresh"), { refreshToken }, { metadata: { ignoreLoading: true } })
        .then((response) => dispatch({ type: "SET_LOGGED", payload: getPayload(response) }))
        .catch(() => dispatch({ type: "SET_LOGGED", payload: null }))
        .finally(() => dispatch({ type: "SET_READY", payload: true }));
      return;
    }

    dispatch([
      { type: "SET_LOGGED", payload: jwt },
      { type: "SET_READY", payload: true },
    ]);
  }, [dispatch]);

  useEffect(() => {
    if (!state.isLogged || !firstLoad.current) return;

    firstLoad.current = false;
    if (location?.pathname === "/login" || location?.pathname === "/primeiro-admin") {
      navigate("/dashboard", { replace: true });
    }
  }, [location?.pathname, navigate, state.isLogged]);

  if (!state.ready) return null;

  return (
    <Routes>
      <Route element={<LayoutEmpty />}>
        <Route path="/login" element={<Login />} />
        <Route path="/primeiro-admin" element={<PrimeiroAdmin />} />
      </Route>

      <Route element={<RequireAuth><LayoutDashboard /></RequireAuth>}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/jobs" element={<JobsPage />} />
        <Route path="/execucoes" element={<ExecucoesPage />} />
      </Route>

      <Route element={<RequireAuth admin><LayoutDashboard /></RequireAuth>}>
        <Route path="/autenticacoes" element={<AutenticacoesPage />} />
        <Route path="/grupos-comunicacao-erro" element={<GruposComunicacaoErroPage />} />
        <Route path="/usuarios" element={<UsuariosPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
